import * as calendar from '../calendar'
import { locales } from '../calendar'

const formatterOptions = {
  topUpCurrencyFormatOptions: { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 }
}
const formatter = {
  topUpCurrencyFormatter: Intl.NumberFormat(locales, formatterOptions.topUpCurrencyFormatOptions)
}

const install = function (Vue, options = {}) {
  const $config = {
    brand: 'otelo',
    calendar,
    formatter,
    validation: {},
    ...options
  }

  Vue.mixin({
    computed: {
      $config () {
        return $config
      }
    }
  })
}

export default {
  install
}
